import { cleanPhone } from './cleanPhone';
export var preparePhone = function preparePhone(phone) {
  var clearPhone = cleanPhone(phone);
  return "+7".concat(clearPhone);
};